import { MobileHeader } from '@components/smart';
import { matchPath, useLocation } from 'react-router-dom';
import { useIsMobile } from '../../hooks/ui/useMediaQuery';

const ROUTES_WITHOUT_HEADER = [
  { path: '/tasks/:id', end: true },
  { path: '/groups', end: true },
  { path: '/tasks-new', end: true },
  { path: '/tasks-new/:id', end: true },
  { path: '/tools/:toolId', end: true },
  { path: '/disk', end: true },
  // Экраны нового бэка: своя шапка, а календарная лента дней с «Встречами» и
  // «Слотами» к ним отношения не имеет.
  { path: '/notifications', end: true },
  { path: '/team', end: true },
  { path: '/profile', end: true },
  { path: '/products', end: true },
  { path: '/events', end: true },
  { path: '/admin/phase0', end: true },
  { path: '/admin/object-types', end: true },
  { path: '/projects-v2', end: true },
  { path: '/projects-v2/:id', end: true },
  { path: '/crm', end: true },
];

const MOBILE_ROUTES_WITHOUT_HEADER = [{ path: '/projects', end: true }];

function matchesAnyRoute(
  pathname: string,
  routes: typeof ROUTES_WITHOUT_HEADER
) {
  return routes.some((route) => matchPath(route, pathname));
}

export function Header() {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  if (!isMobile) {
    return null;
  }

  const isHeaderDisabled = matchesAnyRoute(pathname, ROUTES_WITHOUT_HEADER);
  const isMobileHeaderDisabled = matchesAnyRoute(
    pathname,
    MOBILE_ROUTES_WITHOUT_HEADER
  );

  if (isHeaderDisabled || isMobileHeaderDisabled) {
    return null;
  }

  return <MobileHeader />;
}
